define('CMSadapter.Impl.Categories.v3.Navigation.Fix', [
    'CMSadapter.Impl.Categories.v3',
    'SC.Configuration',
    'jQuery',
    'underscore'
], function CMSadapterImplCategoriesv3NavigationFix(
    CMSadapterImplCategoriesv3,
    Configuration,
    jQuery,
    _
) {
    'use strict';

    /* globals SC */

    _(CMSadapterImplCategoriesv3.prototype).extend({
        setUpEndPoints: function setUpEndPoints() {
            // This patch has been provided by support team in order to fix the CMS internal navigation
            var self = this;
            var companyPath = '/c.' + SC.ENVIRONMENT.companyId;
            var dateEffectiveCategoryPath = self.webStoreUrl.path;
            var nsAtParam = SC.ENVIRONMENT.published.nsScaEnvSlNsAt;
            if (dateEffectiveCategoryPath.indexOf(companyPath) === -1) {
                dateEffectiveCategoryPath = companyPath + dateEffectiveCategoryPath;
            }
            return jQuery.getJSON(this.webStoreUrl.schema + '://' + this.webStoreUrl.netLoc + '/app/site/hosting/scriptlet.nl?script=customscript_ns_' +
                this.product + '_environment&deploy=customdeploy_ns_' + this.product + '_environment' + nsAtParam).then(function thenFunction(env) {
                self.deEffectiveEndpointUrl = 'https://' + env.backendAccountDomain +
                    dateEffectiveCategoryPath.path.replace('{{file}}', 'services/DateEffectiveCategory.Service.ss');
                self.itemEndpointUrl = 'https://' + env.backendAccountDomain + '/api/items';
            });
        }
    });
});

